module.exports = __webpack_public_path__ + "static/media/emoji3.d4999cf6.svg";